import { createRoot } from "react-dom/client";
import { App } from "@/App";
import "@/styles/global.css";
// Ring App Store integration — token aliases + reb-* primitives. Loaded
// after global.css so the alias rules in :root override nothing upstream
// owns and the appstore-only utility classes (reb-button, reb-card, ...)
// are available for the appstore surface.
import "@/styles/appstore.css";
// v6 admin IA — port of mockups/access-preview-v6.html. Loaded last so its
// component classes win over any conflicting legacy admin page CSS.
import "@/styles/v6.css";
// v7 cameras dashboard — port of mockups/cameras-dashboard-v7.html. Loaded
// after v6 so v7-prefixed classes win on the dashboard surface; classes are
// scoped (v7-*) so other pages keep their look.
import "@/styles/v7.css";

const root = document.getElementById("root");
if (!root) {
  throw new Error("missing #root element in index.html");
}

// BUG-01: StrictMode removed — it double-invokes effects in development,
// causing duplicate API calls that inflate audit log entries. The production
// build was unaffected, but the audit trail noise made debugging harder.
createRoot(root).render(<App />);
